// components/Loader.tsx
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import styles from "./Loader.module.css";

const Loader: React.FC = () => {
    return (
        <div className={styles.loaderWrapper}>
            <LoadingOutlined className={styles.spinner} />
            <span className={styles.text}>Loading...</span>
        </div>
    );
};

export default Loader;
